import { render, staticRenderFns } from "./SalesHeadDashboard.vue?vue&type=template&id=67a08c29&scoped=true&"
import script from "./SalesHeadDashboard.vue?vue&type=script&lang=js&"
export * from "./SalesHeadDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SalesHeadDashboard.vue?vue&type=style&index=0&id=67a08c29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a08c29",
  null
  
)

export default component.exports